import React from 'react'

export const WarningBox = ({ children }: { children: React.ReactNode }) => (
  <div
    className='mc-corners--sm mc-p-3 mc-my-6'
    style={{
      background: 'var(--mc-color-yellow-100)',
    }}
  >
    <div className='d-flex'>
      <div aria-live='assertive' className='mc-text-color--dark mc-text-small'>
        {children}
      </div>
    </div>
  </div>
)
